import { translate } from '@gig/magic-common';
import { required } from '@gig/magic-form-builder';
import { getDocumentSideOptions, bothSideTypes } from './document.utils.js';

function documentSide() {
    return {
        id: 'document-side-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        validationBase: 'document-side',
        children: [
            {
                id: 'document-side',
                component: 'magic-ui-dropdown',
                isDataField: true,
                testId: 'document-side',
                properties: {
                    placeholder: translate('verification-upload.side.placeholder'),
                },
                validation: [
                    {
                        name: 'required',
                        fn: required,
                    },
                ],
                preloadProperties: function () {
                    var options = getDocumentSideOptions();
                    return Promise.resolve({
                        options: options,
                        value: options[0].value,
                    });
                },
                triggers: {
                    'document-type': onTypeChange,
                },
                converter: function (formValue) {
                    return { Side: formValue['document-side'].value };
                },
            },
        ],
    };
}
var onTypeChange = function (value, formData, setField) {
    var hidden = !bothSideTypes.includes(value);
    setField({
        id: 'document-side',
        hidden: hidden,
    });
};

export { documentSide };
